var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.campaign.affiliate_link)?_c('div',{staticClass:"notification mtb-5"},[_vm._v("\n    Your link: "),_c('strong',[_vm._v(_vm._s(_vm.campaign.affiliate_link.short_url))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }